import { ReactNode } from 'react';

type Props = {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  // Optional small icon above the title.
  icon?: ReactNode;
  // 'alert' for a failure ("Couldn't load this list"), so it is announced.
  role?: 'alert' | 'status';
};

export function EmptyState({ title, description, action, icon, role }: Props) {
  return (
    <div role={role} className="text-center py-12">
      {icon && <div aria-hidden="true" className="mb-2 flex justify-center text-muted">{icon}</div>}
      <div className="text-lg font-medium text-primary-text">{title}</div>
      {description && <div className="text-sm text-muted mt-2 max-w-md mx-auto">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
